import { axiosGet, axiosPost } from "@/api/request"
import apis from "@/api/apis"

export function handleGetOrderList(data) {
    return axiosGet(apis.orderList, data);
}

export function handleReceiveGoods(data) {
    return axiosPost(apis.receiveGoods, data)
}